import * as React from 'react'

import { SecondaryButton, Space, Text, Divider, Header } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { ActiveUsersWithSlackListPresenter } from '@webapp/platform/integrations/features/list-active-users-with-slack'
import messages from './messages'
import { useSlackUserLinkingSection } from './useSlackUserLinkingSection'

export const SlackUserLinkingSection = () => {
  const intl = useProcurifyIntl()
  const {
    data: { slackUserCache },
    methods: { handleUserLinkChange, syncUnlinkedUsers },
    states: { isSyncing },
  } = useSlackUserLinkingSection()

  return (
    <Space direction='vertical' align='stretch'>
      <Space direction='horizontal'>
        <Space direction='vertical' align='start' size='small'>
          <Header as='h5'>
            {intl.formatMessage(messages.syncUsersHeader)}
          </Header>
          <Text>{intl.formatMessage(messages.syncUsersText)}</Text>
        </Space>
      </Space>
      <SecondaryButton isLoading={isSyncing} onClick={syncUnlinkedUsers}>
        {intl.formatMessage(messages.syncButtonLabel)}
      </SecondaryButton>
      <Divider />

      <Space direction='horizontal'>
        <Space direction='vertical' align='start' size='small'>
          <Header as='h5'>
            {intl.formatMessage(messages.linkUsersHeader)}
          </Header>
          <Text>{intl.formatMessage(messages.linkUsersText)}</Text>
        </Space>
      </Space>
      <ActiveUsersWithSlackListPresenter
        slackUserCache={slackUserCache}
        onUserLinkChange={handleUserLinkChange}
      />
    </Space>
  )
}
